export const getPricelists = (store: Store) => store.pricelists.data;

export const getCurrentPriceList = (store: Store) => store.pricelists.currentPriceList;
